module.exports = __webpack_public_path__ + "img/3-2.4f7d87e1.png";